import { create } from 'zustand'

interface ModalState {
   isApplyPendingModalOpen: boolean
   campaignName: string
   campaignId: string
   openApplyPendingModal: (campaignName: string, campaignId: string) => void
   closeApplyPendingModal: () => void
   getCampaignName: () => string
   getCampaignId: () => string
}

export const useApplyPendingModalStore = create<ModalState>((set, get) => ({
   isApplyPendingModalOpen: false,
   campaignName: '',
   campaignId: '',
   openApplyPendingModal: (campaignName: string, campaignId: string) =>
      set({
         isApplyPendingModalOpen: true,
         campaignName,
         campaignId
      }),
   closeApplyPendingModal: () =>
      set({
         isApplyPendingModalOpen: false,
      }),
   getCampaignName: () => get().campaignName,
   getCampaignId: () => get().campaignId,
}))
